const productLayering = document.querySelector('product-layering');
if (productLayering) {
  const productLayeringSlider = productLayering.querySelector('.product-layering__slider');
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  // Pre-clone slides on mobile so BlazeSlider has enough real slides to loop
  // smoothly without a visible snap-back jump.
  if (productLayeringSlider && mobileQuery.matches) {
    const blazeTrack = productLayeringSlider.querySelector('.blaze-track');
    if (blazeTrack) {
      const originals = [...blazeTrack.querySelectorAll('.product-layering__item')];
      if (originals.length > 1 && originals.length < 4) {
        originals.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-layering-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          const content = clone.querySelector('.item__content');
          if (content) content.setAttribute('inert', '');
          blazeTrack.appendChild(clone);
        });
      }
    }
  }

  const productLayeringItems = productLayering.querySelectorAll('.product-layering__item:not([data-layering-clone])');
  const productLayeringCount = productLayeringItems.length;

  if (productLayeringCount > 1 && productLayeringSlider) {
    const sliderInstance = new BlazeSlider(productLayeringSlider, {
      all: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        slideGap: '9px',
        loop: true,
      },
      '(min-width: 768px)': {
        // Match headless: 3 cards per view with 8px gap (slide width auto-computes ~286px)
        slidesToShow: 3,
        slideGap: '8px',
      },
    });

    // Hide pagination dots that correspond to the pre-cloned duplicate slides
    if (mobileQuery.matches) {
      const paginationEl = productLayeringSlider.querySelector('.blaze-pagination');
      if (paginationEl) {
        paginationEl.querySelectorAll('button').forEach((dot, i) => {
          if (i >= productLayeringCount) {
            dot.style.display = 'none';
            dot.setAttribute('aria-hidden', 'true');
          }
        });
      }

      sliderInstance.onSlide((pageIndex) => {
        const paginationEl = productLayeringSlider.querySelector('.blaze-pagination');
        if (!paginationEl) return;
        const normalized = ((pageIndex % productLayeringCount) + productLayeringCount) % productLayeringCount;
        paginationEl.querySelectorAll('button').forEach((dot, i) => {
          dot.classList.toggle('active', i === normalized);
        });
      });
    }
  }

  if (!productLayeringCount) {
    productLayering.classList.add('hidden');
  }
}
